import { Component, Inject, PACKAGE_ROOT_URL } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../alert.service';
import { AuthService } from '../auth.service';
import { setTimeout } from 'timers';
import { AccountStatsService } from '../account-stats.service';

@Component({
  selector: 'app-agent-dnc-entries',
  templateUrl: './agent-dnc-entries.component.html',
  styleUrls: ['./agent-dnc-entries.component.scss']
})

export class agentDNCEntriesComponent {

  public allApplications: AgentDNCEntry[];
  public statsData: StatsData;
 
  public currentTime = new Date;
  public futureTime = new Date;
  public delay = 0;
  constructor(
    private http: HttpClient,
    private alert: AlertService,
    public accountStats: AccountStatsService,
    public auth: AuthService,
    @Inject('BASE_URL') private baseUrl: string) {

    this.allApplications = [];
    this.statsData = null;

    this.displayData();
  }

  displayData(): void {
    this.http.get<AgentDNCEntry[]>(this.baseUrl + 'api/AgentDNCEntries/Get').subscribe(result => {
      this.allApplications = result;
      this.updateStats();
      this.dailyRefresh(7, 0, 0);
    }, error => {
      this.alert.error(`Error getting applications`, false, 3);
      console.error(error)
    });
  }

  complete(application: AgentDNCEntry): void {
    let agentDNCEntry = this.allApplications.find(x => x.id == application.id);
    let agentDNCEntryHist = new AgentDNCEntryHist();
    agentDNCEntryHist.id= agentDNCEntry.id;
    agentDNCEntryHist.agentEmailAddress = agentDNCEntry.agentEmailAddress;
    agentDNCEntryHist.accountNumber = agentDNCEntry.accountNumber;
    agentDNCEntryHist.completionCode = "Done";
    agentDNCEntryHist.insertDateTime = agentDNCEntry.insertDateTime;
    agentDNCEntryHist.insertUserId = agentDNCEntry.insertUserId;
    agentDNCEntryHist.phoneNumber = agentDNCEntry.phoneNumber;
    agentDNCEntryHist.thirdPartyType = agentDNCEntry.thirdPartyType;
  
    this.http.post(this.baseUrl + 'api/AgentDNCEntries/Update', agentDNCEntryHist).subscribe(() => {    
      this.displayData();
    }, error => {
      this.alert.error("Error while updating this worklist", false, 3);
      console.error(error)
    });
  }

  dailyRefresh(hours, minutes, seconds): void {
    var targetRefreshTime = new Date(); //time when this method gets called
    var localTimeForThisMethod = new Date(); //time when this method gets called

    targetRefreshTime.setDate(this.currentTime.getDate() + 1); //put target refresh time a day into the future

    targetRefreshTime.setHours(hours); //target refresh hour from method parameters
    targetRefreshTime.setMinutes(minutes); //target refresh minute from method parameters
    targetRefreshTime.setSeconds(seconds); //target refresh second from method parameters

    var timeUntilReset = (targetRefreshTime.getTime() - localTimeForThisMethod.getTime()); //determine time until next reset
    setTimeout(() => this.displayData(), Math.abs(timeUntilReset)); //call reset cache at target time. This will update next taget refresh time to next day as well
  }

  updateStats(): void {
    this.http.get<StatsData>(this.baseUrl + 'api/AgentDNCEntries/GetStatsData').subscribe(result => {
      this.statsData = result;

      this.accountStats.TotalDNCNumbers = this.statsData.total;
      this.accountStats.TodoDNCNumbers = this.statsData.inQueue;
      this.accountStats.DoneDNCNumbers = this.statsData.completedToday;

    }, error => {
      this.alert.error(`Error getting applications`, false, 3);
      console.error(error)
    });
  }
}

class AgentDNCEntry {
    id: any;
    insertDateTime: Date;
    insertUserId: string;
    phoneNumber: string;
    accountNumber: string;
    thirdPartyType: string;
    agentEmailAddress: string;
  }

  class AgentDNCEntryHist {
    id: any;
    insertDateTime: Date;
    insertUserId: string;
    phoneNumber: string;
    accountNumber: string;
    thirdPartyType: string;
    agentEmailAddress: string;
    completionCode: string;
    updatedDateTime: Date;
    updatedBy: string;
  }

  class StatsData {
    completedToday: number;
    total: number;
    inQueue: number;
  
    constructor() {
      this.completedToday = 0;
      this.inQueue = 0;
      this.total = 0;
    }
  }


// WEBPACK FOOTER //
// ./src/app/agent-dnc-entries/agent-dnc-entries.component.ts